<template>
    <div class="container register mt-5">
        <h2 class="fw-bold text-dark text-center mb-4">{{ editingTemplateId ? 'Edit Template' : 'Add Template' }}</h2>
        <div class="glass-panel p-5">
            <div class="text-center mb-5">
                <img class="logo" alt="Vue logo" src="@lib/frontend/assets/new.png" style="max-height: 80px;">
            </div>
            <form class="form">
                <div class="row g-4">
                    <!-- Row 1 -->
                    <div class="col-md-4">
                        <label for="tour_name" class="form-label text-muted small fw-bold mb-2">Tour Name</label>
                        <input v-model="post.data.tour_name" type="text" id="tour_name" class="form-control" required placeholder="Enter tour name" />
                    </div>
                    <div class="col-md-4">
                        <label for="cruise_line" class="form-label text-muted small fw-bold mb-2">Cruise Line</label>
                        <select v-model="post.data.cruise_line" id="cruise_line" class="form-control" required>
                            <option :value="null" disabled>Select a Cruise Line</option>
                            <option v-for="cruiseLine in cruiseLines" :key="cruiseLine.id" :value="cruiseLine.id">
                                {{ cruiseLine.attributes.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <label for="city" class="form-label text-muted small fw-bold mb-2">Visiting City</label>
                        <input v-model="post.data.city" type="text" id="city" class="form-control" required placeholder="e.g. Berlin" />
                    </div>

                    <!-- Row 2 -->
                    <div class="col-md-4">
                        <label for="end_city" class="form-label text-muted small fw-bold mb-2">End City</label>
                        <input v-model="post.data.end_city" type="text" id="end_city" class="form-control" required placeholder="e.g. Hamburg" />
                    </div>
                    <div class="col-md-4">
                        <label for="type" class="form-label text-muted small fw-bold mb-2">Type (Train/Bus)</label>
                        <select v-model="post.data.type" id="type" class="form-control" required>
                            <option v-for="type in possibleTypes" :key="type" :value="type">{{ type }}</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <label for="address_tc" class="form-label text-muted small fw-bold mb-2">Time Change Address</label>
                        <input v-model="post.data.address_tc" type="text" id="address_tc" class="form-control" required placeholder="Address" />
                    </div>

                    <!-- Row 3 -->
                    <div class="col-md-4">
                        <label for="emergency_contactUS" class="form-label text-muted small fw-bold mb-2">American Embassy Contact</label>
                        <input v-model="post.data.emergency_contactUS" type="text" id="emergency_contactUS" class="form-control" required placeholder="Phone number" />
                    </div>
                    <div class="col-md-4">
                        <label for="emergency_contactUSconsulate" class="form-label text-muted small fw-bold mb-2">American Consulate Contact</label>
                        <input v-model="post.data.emergency_contactUSconsulate" type="text" id="emergency_contactUSconsulate" class="form-control" required placeholder="Phone number" />
                    </div>
                    <div class="col-md-4">
                        <label for="address_US" class="form-label text-muted small fw-bold mb-2">American Embassy Address</label>
                        <input v-model="post.data.address_US" type="text" id="address_US" class="form-control" required placeholder="Address" />
                    </div>

                    <!-- Row 4 -->
                    <div class="col-md-4">
                        <label for="address_USconsulate" class="form-label text-muted small fw-bold mb-2">American Consulate Address</label>
                        <input v-model="post.data.address_USconsulate" type="text" id="address_USconsulate" class="form-control" required placeholder="Address" />
                    </div>
                    <div class="col-md-4">
                        <label for="emergency_contactUK" class="form-label text-muted small fw-bold mb-2">British Embassy Contact</label>
                        <input v-model="post.data.emergency_contactUK" type="text" id="emergency_contactUK" class="form-control" required placeholder="Phone number" />
                    </div>
                    <div class="col-md-4">
                        <label for="address_UK" class="form-label text-muted small fw-bold mb-2">British Embassy Address</label>
                        <input v-model="post.data.address_UK" type="text" id="address_UK" class="form-control" required placeholder="Address" />
                    </div>

                    <!-- Conditional Row 5 -->
                    <div v-if="isUKConsulateRequired" class="col-md-4">
                        <label for="address_UKconsulate" class="form-label text-muted small fw-bold mb-2">British Consulate Address</label>
                        <input v-model="post.data.address_UKconsulate" type="text" id="address_UKconsulate" class="form-control" required placeholder="Address" />
                    </div>
                    <div v-if="isUKConsulateRequired" class="col-md-4">
                        <label for="emergency_contactUKconsulate" class="form-label text-muted small fw-bold mb-2">British Consulate Contact</label>
                        <input v-model="post.data.emergency_contactUKconsulate" type="text" id="emergency_contactUKconsulate" class="form-control" required placeholder="Phone number" />
                    </div>
                </div>

                <div class="text-center mt-5 d-flex justify-content-center gap-3">
                    <button v-if="editingTemplateId" type="button" @click="updateTemplate" class="btn btn-primary px-5 py-2 rounded-pill shadow-sm fw-bold">Update Template</button>
                    <button v-else type="button" @click="addTemplate" class="btn btn-primary px-5 py-2 rounded-pill shadow-sm fw-bold">Add Template</button>
                    <router-link :to="{ name: 'Templates' }" class="btn btn-light px-5 py-2 rounded-pill shadow-sm fw-bold text-dark text-decoration-none">Cancel</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            post: {
                data: {
                    tour_name: "",
                    cruise_line: null,
                    city: "",
                    end_city: "",
                    type: "",
                    address_tc: "",
                    emergency_contactUS: "",
                    address_US: "",
                    emergency_contactUSconsulate: "",
                    address_USconsulate: "",
                    emergency_contactUK: "",
                    address_UK: "",
                    address_UKconsulate: "",
                    emergency_contactUKconsulate: "",
                },
            },
            editingTemplateId: null,
            cruiseLines: [],
            possibleTypes: ["Train", "Bus", "Train and Bus"],
        };
    },
    computed: {
        isUKConsulateRequired() {
            const cities = ['hamburg', 'kiel', 'lubeck'];
            const city = this.post.data.city.toLowerCase();
            const endCity = this.post.data.end_city.toLowerCase();
            return cities.includes(city) || cities.includes(endCity);
        },
    },
    async created() {
        await this.fetchCruiseLines();
        const id = this.$route.params.id;
        if (id) {
            this.editingTemplateId = id;
            await this.fetchTemplateById(id);
        }
    },
    methods: {
        async fetchCruiseLines() {
            const response = await this.$xhr.get("/api/cruise-lines?populate=*");
            this.cruiseLines = response.data.data;
            console.log('Fetched cruiseLines:', this.cruiseLines);
        },
        async addTemplate() {
            try {
                const payload = { ...this.post };
                if (!this.isUKConsulateRequired) {
                    delete payload.data.address_UKconsulate;
                    delete payload.data.emergency_contactUKconsulate;
                }
                const response = await this.$xhr.post("/api/sk-templates", payload);
                if (response.status === 200) {
                    this.$bvToast.toast('Template successfully created!', { title: 'Success', variant: 'success', solid: true });
                    this.$router.push({ name: 'Templates' });
                }
            } catch (error) {
                console.error(error);
                this.$bvToast.toast('Failed to create template.', { title: 'Error', variant: 'danger', solid: true });
            }
        },
        async updateTemplate() {
            try {
                const payload = { ...this.post };
                if (!this.isUKConsulateRequired) {
                    delete payload.data.address_UKconsulate;
                    delete payload.data.emergency_contactUKconsulate;
                }
                const response = await this.$xhr.put(`/api/sk-templates/${this.editingTemplateId}`, payload);
                if (response.status === 200) {
                    this.$bvToast.toast('Template successfully updated!', { title: 'Success', variant: 'success', solid: true });
                    this.$router.push({ name: 'Templates' });
                }
            } catch (error) {
                console.error(error);
                this.$bvToast.toast('Failed to update template.', { title: 'Error', variant: 'danger', solid: true });
            }
        },
        async fetchTemplateById(id) {
            const response = await this.$xhr.get(`/api/sk-templates/${id}?populate=cruise_line`);
            const responseData = response.data.data;
            console.log('Template response:', responseData);
            this.post.data.tour_name = responseData.attributes.tour_name;
            this.post.data.cruise_line = responseData.attributes.cruise_line?.data?.id || null;
            this.post.data.city = responseData.attributes.city;
            this.post.data.end_city = responseData.attributes.end_city;
            this.post.data.type = responseData.attributes.type;
            this.post.data.address_tc = responseData.attributes.address_tc;
            this.post.data.address_US = responseData.attributes.address_US;
            this.post.data.address_USconsulate = responseData.attributes.address_USconsulate;
            this.post.data.emergency_contactUS = responseData.attributes.emergency_contactUS;
            this.post.data.emergency_contactUSconsulate = responseData.attributes.emergency_contactUSconsulate;
            this.post.data.address_UK = responseData.attributes.address_UK;
            this.post.data.emergency_contactUK = responseData.attributes.emergency_contactUK;
            this.post.data.address_UKconsulate = responseData.attributes.address_UKconsulate || "";
            this.post.data.emergency_contactUKconsulate = responseData.attributes.emergency_contactUKconsulate || "";
            // Verify cruise_line value is valid
            if (this.post.data.cruise_line && !this.cruiseLines.some(cl => cl.id === this.post.data.cruise_line)) {
                console.warn(`Cruise line ID ${this.post.data.cruise_line} not found in cruiseLines, resetting to null`);
                this.post.data.cruise_line = null;
            }
        },
    },
};
</script>


<style scoped>
.container {
  max-width: 1400px;
}

.logo {
    margin: auto;
    display: block;
    max-width: 330px;
}

label {
    font-weight: bold;
}

.form-group {
    margin-bottom: 15px;
}
</style>